import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'

@InputType()
export class SaveHaulerArgs extends ActionArgs {
  @Field(() => ID, { nullable: true })
  _id?: string

  @Field(() => String, { nullable: true })
  name?: string

  @Field(() => String, { nullable: true })
  code?: string

  @Field(() => String, { nullable: true })
  status?: string

  @Field(() => String, { nullable: true })
  contactFirstName?: string

  @Field(() => String, { nullable: true })
  contactLastName?: string

  @Field(() => String, { nullable: true })
  remarks?: string

  @Field(() => [String], { nullable: true })
  tags?: string[]
}
